import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import { View, ScrollView } from '@dbk/ui-react-utils';
import find from 'lodash/find';
import pullAll from 'lodash/pullAll';
import pull from 'lodash/pull';
import remove from 'lodash/remove';
import map from 'lodash/map';
import extend from 'lodash/extend';
import filter from 'lodash/filter';
import findIndex from 'lodash/fp/findIndex';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import styles from './advices.styles';
import AdvicesMarkAsReadOrDownload from './advices-mark-as-read';
import AdvicesSelectAll from './advices-select-all';
import AdvicesRowItem from './advices-row-item';
import ReportPreview from '../../../../screens/reports/report-preview';
import download from '../../../../../../../src/muster/utils/downloader';
import { CSV, PDF, TXT, SUCCESS_RESPONSE_CODE } from '../../../../screens/reports/constants';
// import { LoadingCircle } from '../../../../components/common/loading

class TransactionSecurityAdviceList extends PureComponent {

    state = {
        isSelectAllChecked: false,
        selectedIdsForMarkAsRead: [],
        selectedIdsForDownload: [],
        documentListForDownload: [],
        selectedCategoryList: [],
        advicesList: [],
        modalVisible: false,
        documentId: null,
        docName: null,
        pdfByteStream: '',
        downloadInProgress: false,
        extType: '',
        documentType: '',
        errorHeader: ''

    }

    componentWillUnmount(){
        const {
          reports: {
            transaction: {
              securityAdviceList,
            }
          },
        } = this.props;

        this.props.setSecurityAdviceList("");
        this.props.setTitle(null);
      }

    closePdf = () => {
        this.setState({ documentId: null });
    }

    closeBlurModel = () => {
        if (this.state.documentId != null) {
            return;
        }
        this.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', errorHeader: '' });
        this.props.reports.setPdfBinaryData('');
    }

    onItemClicked = (document) => {
        this.setState({ modalVisible: true, documentId: document.adviceDocumentId, docName: document.adviceDocumentName });
        this.previewDocument(document.adviceDocumentId);
    }

    downloader = () => {
        // 16560003 csv
        // 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003
        // const filesToDownload = [13674003]; // 13678003, 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003];
        const {
            settings: { currentEnvironment: { remoteUrl } },
            auth: { userId, authHeader, langCode },
            i18n: { messages }
        } = this.props;

        const RSA_URL = remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';
        // const RSA_URL = 'https://sinasebankd3.sg.db.com:8243/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';

        this.props.setShowSpinner(true);
        for (let j = 0; j < this.state.selectedIdsForDownload.length; j++) {
            const body = { "userId": userId, "branchCode": this.props.app.user.selectedPortfolio.branchCode, "channel": "WEB", "language": langCode, "documentIds": [this.state.selectedIdsForDownload[j]] };
            let documentName = '';
            documentName = this.state.documentListForDownload[j].documentName;
            const that = this;

            const x = new XMLHttpRequest();
            x.open('POST', RSA_URL, true);
            x.setRequestHeader('Authorization-Token', authHeader);
            x.setRequestHeader('content-type', 'application/json');
            x.setRequestHeader('Accept', 'application/octet-stream');
            // x.setRequestHeader('Authorization', 'Bearer f8dc3328de0d59cdbe80b8dec304a1a2');
            // x.setRequestHeader("Access-Control-Allow-Origin", "*");
            // x.setRequestHeader("Access-Control-Allow-Credentials", "true");
            // x.setRequestHeader("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
            // x.setRequestHeader("Access-Control-Allow-Headers", "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers");

            x.setRequestHeader(
                'Content-Disposition',
                'inline; filename=' + documentName
            );
            x.setRequestHeader(
                'Cache-Control',
                'no-cache, no-store, must-revalidate'
            );
            x.setRequestHeader('Pragma', 'no-cache');
            x.setRequestHeader('Expires', '0');
            x.responseType = 'arraybuffer';
            x.timeout = 300000;
            x.ontimeout = function () {
                that.props.setShowSpinner(false); that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
            }

            x.onload = function (e) {
                if (x.status === SUCCESS_RESPONSE_CODE) {
                    const documentType = x.getResponseHeader('content-type');
                    // const ext = documentType.split('/');
                    let ext = '';
                    if (documentType.includes('/pdf')) {
                        ext = PDF;
                    } else if (documentType.includes('/csv')) {
                        ext = CSV;
                    } else if (documentType.includes('/text')) {
                        ext = TXT;
                    }

                    download(x.response, documentName + ext, documentType); // text/csv and
                    // if (j === (that.state.selectedIdsForDownload.length - 1)) {
                    //     that.props.getDocuments().then(() => {
                    //         that.setState({ downloadLoadingFlag: false });
                    //     });

                    // }
                } else {
                    that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
                }

                that.props.setShowSpinner(false);
            };

            x.send(JSON.stringify(body));

            x.onerror = function (e) {
                that.props.setShowSpinner(false);
                that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
            };
        }
    }

    detectIE = () => {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE '); // IE 10 or older => return version number
        const trident = ua.indexOf('Trident/'); // IE 11 => return version number
        const edge = ua.indexOf('Edge/'); // IE 12 => return version number
        if (msie > 0 || trident > 0 || edge > 0) {
            return true;
        }
        return false;
    }

    /**
     * function to preview document,
     * WMCE-3044, documentDownloadDisabled flag added to diable document download and preview on 
     * RM Login on Behalf
     */
    previewDocument = (documentId) => {
        // 16560003 csv
        // 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003
        // const filesToDownload = [13674003]; // 13678003, 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003];
        const {
            settings: { currentEnvironment: { remoteUrl } },
            auth: { userId, authHeader, langCode, documentDownloadDisabled },
            i18n: { messages }
          } = this.props;

        this.setState({ downloadInProgress: true });

        const RSA_URL = remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';

        // const RSA_URL = 'https://sinasebankd3.sg.db.com:8243/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';

        const body = { "userId": userId, "branchCode": this.props.app.user.selectedPortfolio.branchCode, "channel": "WEB", "language": langCode, "documentIds": [documentId] };
        const documentName = '';
        const that = this;
        this.props.setShowSpinner(true);
        const x = new XMLHttpRequest();
        x.open('POST', RSA_URL, true);
        x.setRequestHeader('Authorization-Token', authHeader);
        x.setRequestHeader('content-type', 'application/json');
        x.setRequestHeader('Accept', 'application/octet-stream');
        // x.setRequestHeader('Authorization', 'Bearer f8dc3328de0d59cdbe80b8dec304a1a2');
        x.setRequestHeader(
            'Content-Disposition',
            'inline; filename=' + documentName
        );
        x.setRequestHeader(
            'Cache-Control',
            'no-cache, no-store, must-revalidate'
        );
        x.setRequestHeader('Pragma', 'no-cache');
        x.setRequestHeader('Expires', '0');
        x.responseType = 'arraybuffer';
        x.timeout = 300000;
        x.ontimeout = function () { that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']); }

        x.onload = function (e) {
            if (x.status === SUCCESS_RESPONSE_CODE) {
                const documentType = x.getResponseHeader('content-type');
                // const ext = documentType.split('/');
                let ext = '';
                if (documentType.includes('/pdf')) {
                    ext = '.pdf';
                } else if (documentType.includes('/csv')) {
                    ext = '.csv';
                } else if (documentType.includes('/text')) {
                    ext = '.txt';
                }

                if (that.detectIE()){
                    if(!documentDownloadDisabled){
                    download(x.response, that.state.docName + ext, documentType); // text/csv and
                    that.props.getDocuments();
                    }
                    that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', errorHeader: '', downloadInProgress: false });
                    return;
                }


                if (ext !== ".pdf") {
                    if(documentDownloadDisabled){
                        that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', errorHeader: '', downloadInProgress: false });
                        that.props.setBlurModalError(messages['app.rmAccess.genericError']);
                    }
                    else
                    that.setState({ pdfByteStream: x.response, extType: ext, documentType, errorHeader: messages['app.chedelivery.reports.unsupportedTypeHeader'], downloadInProgress: false });
                }else
                    that.setState({ pdfByteStream: x.response, extType: ext, documentType, downloadInProgress: false });
            } else {
                that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', errorHeader: '', downloadInProgress: false });
                that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
            }
            that.props.setShowSpinner(false);
        };
        x.send(JSON.stringify(body));
        x.onerror = function (e) {
            that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', errorHeader: '', downloadInProgress: false });
            that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
        };
    }

    componentWillMount() {
        const { i18n: {
            messages } } = this.props;
        this.props.setTitle(messages['app.chedelivery.reports.advices']);
    }

    componentDidMount() {
        // TODO:: make api call for advices list
        const list = this.props.reports.transaction.securityAdviceList;
        // const data = JSON.parse('{"dwoMessage":{"messages":null,"responseType":"SUCCESS"},"returnCode":"0","documentDetails":[{"adviceDocumentId":2752003,"adviceDocumentName":"Advices-18072017-2752003","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":true},{"adviceDocumentId":2752004,"adviceDocumentName":"Advices-19072018-2752004","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false},{"adviceDocumentId":2752005,"adviceDocumentName":"Advices-18072017-2752005","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false},{"adviceDocumentId":2752006,"adviceDocumentName":"Advices-18072017-2752006","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false},{"adviceDocumentId":2752007,"adviceDocumentName":"Advices-18072017-2752007","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false},{"adviceDocumentId":2752008,"adviceDocumentName":"Advices-18072017-2752008","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false},{"adviceDocumentId":2752009,"adviceDocumentName":"Advices-18072017-2752009","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false},{"adviceDocumentId":2752010,"adviceDocumentName":"Advices-18072017-2752010","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false},{"adviceDocumentId":2752011,"adviceDocumentName":"Advices-18072017-2752011","refCurrency":"EUR","portfolioId":"01110788.58","receivedDate":"2018-05-15T00:00:00+02:00","read":false}]}');
        this.setComponentData(list);
    }

    /**
     * modify advices list and set data
     */
    setComponentData = (list) => {
        const updatedList = map(list, o => extend({ isChecked: false }, o));
        this.setState({
            advicesList: updatedList,
            isSelectAllChecked: false,
            selectedIdsForMarkAsRead: [],
            selectedIdsForDownload: [],
            selectedCategoryList: []
        });
    }


    /**
    * function to check if all items in category are checked or not
    * if not select all checkbox will be unchecked
    */
    checkAllItemCheckedInCategory = (list) => {
        const selectedCategoryList = { ...list };
        const checkedList = filter(selectedCategoryList.documentDetails, (o) => (o.isChecked === false));
        if (checkedList && checkedList.length > 0) {
            return false;
        }
        return true;
    }



    /**
     * method to handle select all checkbox click.
     * this will store all selected report ids into an array.
     * later, the array will be used for 'Mark as read' functionality
     */
    handleSelectAllClick = () => {
        let checked = false;
        let documentsIdList = [];
        const documentsForDownload = [];
        const list = [...this.state.advicesList];
        if (this.state.isSelectAllChecked) {
            checked = false;
        } else {
            checked = true;
            if (list && list.length > 0) {
                documentsIdList = map(list, 'adviceDocumentId');
            }
        }

        map(list, (o) => {
            if (checked) {
                const checkedItem = { documentId: o.adviceDocumentId, documentName: o.adviceDocumentName };
                documentsForDownload.push(checkedItem);
            }
            o.isChecked = checked;
        });

        // setting state with updated list
        this.setState({
            advicesList: list,
            selectedIdsForMarkAsRead: documentsIdList,
            selectedIdsForDownload: documentsIdList,
            isSelectAllChecked: checked,
            documentListForDownload: documentsForDownload
        });
    }

    /**
     * function to handle document checkbox
     */
    handleDocumentCheckboxClick = (documentObj) => {
        const list = [...this.state.advicesList];
        // array to store list of document object, will be used for download functionality
        const docsForDownload = [...this.state.documentListForDownload];
        const idsForDownload = [...this.state.selectedIdsForDownload];
        const documentIndex = findIndex({ adviceDocumentId: documentObj.adviceDocumentId }, list);
        const document = find(list, { adviceDocumentId: documentObj.adviceDocumentId });

        if (document) {
            if (document.isChecked) {
                document.isChecked = false;
                pull(idsForDownload, documentObj.adviceDocumentId);
                // remove document from docsForDownload
                remove(docsForDownload, { documentId: documentObj.adviceDocumentId });
            } else {
                document.isChecked = true;
                let checkedItem = find(list, { adviceDocumentId: documentObj.adviceDocumentId });
                if (checkedItem) {
                    checkedItem = { documentId: documentObj.adviceDocumentId, documentName: documentObj.adviceDocumentName };
                    docsForDownload.push(checkedItem);
                }
                idsForDownload.push(documentObj.adviceDocumentId);
            }

            list[documentIndex] = document;
            const isSelectAllChecked = this.getSelectAllChecked(list);
            this.setState({
                advicesList: list,
                selectedIdsForDownload: idsForDownload,
                isSelectAllChecked,
                documentListForDownload: docsForDownload
            })
        }

    }

    /**
   * method to handle onPress of Download/ Preview
   */
    handlePreviewnDownloadClick = () => {
        // this.props.downloadDocuments(this.state.selectedIdsForDownload[0]);
        // this.setState({ downloadLoadingFlag: true });
        this.downloader();
    }

    /**
     * function to check if all items are checked
     */
    getSelectAllChecked = (list) => {
        const checkedDocuments = filter(list, (o) => (o.isChecked === false));
        if (checkedDocuments && checkedDocuments.length > 0)
            return false;
        return true;
    }

    /**
     * function to return select all view
     */
    getAdvicesListHeader = (isTablet) => (
        <AdvicesSelectAll
            isTablet={isTablet}
            handleSelectAllClick={() => this.handleSelectAllClick()}
            isSelectAllChecked={this.state.isSelectAllChecked}
        />)

    /**
     * function to return mark as read view
     */
    getMarkAsReadView = () => {
        if (this.state.selectedIdsForDownload.length > 0) {
            return (
                <AdvicesMarkAsReadOrDownload
                    downloadCount={this.state.selectedIdsForDownload.length}
                    handlePreviewnDownloadClick={this.handlePreviewnDownloadClick}
                    downloadDisabled ={this.props.auth.documentDownloadDisabled}
                // downloadLoadingFlag={this.state.downloadLoadingFlag}
                />
            );
        }
    }

    /**
     * function to return report doclist body
     */
    getAdvicesListBody = () => {
        const list = [...this.state.advicesList];
        // TODO:: check below condition with empty data.
        if (list &&
            list.length > 0) {
            return (
                list.map((item) => (
                    <NavigationListItem tabIndex={-1} hasArrow={false} >
                        <AdvicesRowItem
                            handleDocumentCheckboxClick={this.handleDocumentCheckboxClick}
                            item={item}
                            handlePreviewClick={this.onItemClicked} />
                    </NavigationListItem >
                )
                ));
        }
        // if no items in documentDetails then show no records found view
        return (<View />);
    }

    render() {

        const { i18n: { messages },
        } = this.props;
        const paddingStyle = { paddingLeft: 5, paddingRight: 10 };

        // if ( (this.state.selectedCategoryList && this.state.selectedCategoryList.documentMetadataList.length > 0) ||
        //     this.state.unreadList.length > 0) {
        return (
            <div className="row large-collapse">
                <div className="profile-container">
                    <div className="profile-container__title" style={{ paddingLeft: 20 }}>
                        <h2 tabIndex={0}>{messages['app.common.pageTitle.advice']}</h2>
                    </div>
                    <View style={[paddingStyle, { flex: 1, flexDirection: 'column' }]}>
                        {this.getAdvicesListHeader()}
                        <div style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "550px" }}>
                            <ScrollView >
                                <NavigationList inverse >
                                    {this.getAdvicesListBody()}
                                </NavigationList>
                            </ScrollView>
                        </div>
                        {this.getMarkAsReadView()}

                        <ReportPreview
                            screen={screen}
                            modalVisible={this.state.modalVisible}
                            doneLabel="Done"
                            onCloseBlurModel={this.closeBlurModel}
                            headerLabel={this.state.docName}
                            closePdf={this.closePdf}
                            pdfData={this.state.pdfByteStream}
                            messages={messages}
                            pdfDataDownloadInProgress={this.state.downloadInProgress}
                            extType={this.state.extType}
                            documentType={this.state.documentType}
                            errorHeader={this.state.errorHeader}
                            documentDownloadDisabled={this.props.auth.documentDownloadDisabled}
                        />
                    </View >
                </div>
            </div>


        );
    }
}

TransactionSecurityAdviceList.propTypes = {
    i18n: PropTypes.shape({
        messages: PropTypes.object,
    }),
};

TransactionSecurityAdviceList.defaultProps = {
    i18n: {},
};

export default createContainer(
    {
        // $renderLoading: () => <LoadingCircle />,
        $queries: {
            setTitle: {
                $set: 'ui.customtitle',
            },
            i18n: {
                messages: true,
            },
            markDocumentsAsRead: {
                $call: 'reports.markDocumentsAsRead'
            },
            setTotalDocs: {
                $call: 'reports.setTotalDocs'
            },
            setInitialReportsCall: {
                $set: 'reports.initialReportsCall'
            },
            reports: {
                showSpinner: true,
                transaction: {
                    securityAdviceList: true,
                },
                pdfBinaryData: true,
                setPdfBinaryData: {
                    $set: 'pdfBinaryData',
                },
                pdfDataDownloadInProgress: true,

            },
            app: {
                global: {
                    deviceInfo: {
                        width: true,
                        height: true,
                    },
                },
                config: {
                    apiverion: true
                },
                user: {
                    selectedPortfolio: true,
                }
            },
            settings: {
                currentEnvironment: {
                    remoteUrl: true,
                },
            },
            auth: {
                userId: true,
                authHeader: true,
                langCode: true,
                documentDownloadDisabled: true,
            },
            downloadDocuments: {
                $call: 'reports.downloadDocuments'
            },
            setBlurModalError: {
                $call: 'reports.setBlurModalError'
            },
            setShowSpinner: {
                $set: 'reports.showSpinner'
            },
            setSecurityAdviceList: {
                $set: 'reports.transaction.securityAdviceList'
              },
        },
    }
)(TransactionSecurityAdviceList);
